import Breadcrumb from '@Services/Breadcrumb';
import { buildChainKey } from './constants';

export function resolveSummaryChain(activeBreadcrumb, fallbackDatabaseId) {
  const rootBreadcrumb = Breadcrumb.retrieveRootActiveBreadcrumb(activeBreadcrumb);
  const databaseId = activeBreadcrumb?.databaseId || fallbackDatabaseId;
  const context = activeBreadcrumb?.context;

  return {
    rootBreadcrumb,
    chainKey:
      databaseId && context && rootBreadcrumb?.resultName
        ? buildChainKey({ databaseId, context, rootResultName: rootBreadcrumb.resultName })
        : null,
  };
}

export function resolveSummaryRequestParams({ activeBreadcrumb, params, chainKey }) {
  const rootBreadcrumb = Breadcrumb.retrieveRootActiveBreadcrumb(activeBreadcrumb);
  const query =
    rootBreadcrumb?.quickSearchItem?.content ||
    rootBreadcrumb?.textQuery ||
    activeBreadcrumb?.quickSearchItem?.content ||
    activeBreadcrumb?.textQuery;

  return {
    chainKey,
    resultName: params?.resultName ?? activeBreadcrumb?.resultName,
    databaseId: params?.databaseId ?? activeBreadcrumb?.databaseId,
    context: activeBreadcrumb?.context,
    sort: params?.sort ?? activeBreadcrumb?.sort,
    order: params?.order ?? activeBreadcrumb?.order,
    pageNumber: params?.pageNumber ?? activeBreadcrumb?.pageNumber,
    query,
    semanticResultName: activeBreadcrumb?.semanticResultName,
  };
}
